import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionSummary,
    Badge,
    BadgeProps,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyAccordionContainer = styled(Accordion, {
    name: 'StyAccordion',
})(({ theme }) => ({
    width: '100%',
    marginTop: '1rem !important',
    borderRadius: '0.5rem !important',
    '&::before': {
        visibility: 'hidden',
    },
    backgroundColor: theme.palette.lightGrey,
}));

const StyledBadge = styled(Badge, {
    name: 'StyledBadge',
})<BadgeProps>({
    '& .MuiBadge-badge': {
        width: '18px',
        height: '18px',
    },
});

type Props = {
    title: string;
    defaultExpanded?: boolean;
    children?: React.ReactNode;
    badgeContent?: number;
};

export const HypothesesAccordion = ({
    title,
    children,
    defaultExpanded,
    badgeContent = 0,
}: Props) => (
    <StyAccordionContainer elevation={0} defaultExpanded={defaultExpanded}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <StyledBadge
                color="error"
                invisible={badgeContent === 0}
                badgeContent={<span>{badgeContent}</span>}
            >
                <Typography
                    sx={() => ({
                        color: 'primary.main',
                        fontSize: '16px',
                        fontWeight: 600,
                    })}
                >
                    {title}
                </Typography>
            </StyledBadge>
        </AccordionSummary>
        {children}
    </StyAccordionContainer>
);
